;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';
import { createCookieConsentGatedOTelWebConfig } from '@framework/otel/createCookieConsentGatedOTelWebConfig';
import createCookieConsentGatedSentryConfig from '@framework/sentry/createCookieConsentGatedSentryConfig';

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

createCookieConsentGatedSentryConfig({ entry: 'finsight', client: true });
createCookieConsentGatedOTelWebConfig({ entry: 'finsight' });
